/* Page Builder — client behavior.
   Add-to-cart for any [data-pb-add] button: POST the variant to /cart/add.js, then
   send the shopper to data-next (the next funnel step). No page reload on the add itself,
   so the funnel feels instant. Falls back to an alert on failure. */
(function () {
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-pb-add]");
    if (!btn) return;
    e.preventDefault();

    var body = {
      id: btn.getAttribute("data-variant"),
      quantity: parseInt(btn.getAttribute("data-qty") || "1", 10)
    };
    var sellingPlan = btn.getAttribute("data-selling-plan");
    if (sellingPlan) body.selling_plan = sellingPlan;

    var next = btn.getAttribute("data-next") || "/cart";
    var label = btn.textContent;
    btn.setAttribute("aria-busy", "true");
    btn.style.opacity = "0.7";
    btn.style.pointerEvents = "none";
    btn.textContent = "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || "Couldn't add to cart"); });
        return r.json();
      })
      .then(function () { window.location.href = next; })
      .catch(function (err) {
        btn.removeAttribute("aria-busy");
        btn.style.opacity = "1";
        btn.style.pointerEvents = "";
        btn.textContent = label;
        window.alert(err.message || "Sorry, that couldn't be added. Please try again.");
      });
  });
})();
